<template>
  <div class="post-content">
    <div class="row row--flex">
      <div class="col-70">
        <p>
          This guide emerged out of determination bordering on desperation.
          Whenever I was looking for more sustainable printing solutions, all I
          came across were marketing tricks advertising ostensibly eco-friendly
          products and machines, all in the “make printing green again!” vibe.
          More than once, I had to listen to the printers’ serenades (“No can
          do, M’am, no can do!”), and I most certainly had my fill of
          vaguely-ecology-related novelty solutions that only drag the designers
          and clients away from the simple and straightforward solutions. Having
          collected the materials and consulted my information with experts, I
          condensed it all into bite-sized chapters. I hope this project keeps
          on growing and expanding, starting with information on more
          sustainable packagings or labels, for example. This booklet has not
          been made on kale-enriched tofu paper, but I believe it can still help
          you with your work. This is not a complete, closed project. If you
          have any questions or ideas, go ahead and send me a message (CLICK).
          Share this guide with others, let it travel. If you want to show us
          your prints and experiences, we’ll be delighted to publish them, too.
        </p>
      </div>
      <Sidenote class="col-30">
        <p>In which we share our knowledge</p>
      </Sidenote>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p>
          Perhaps some of the information in this guide was surprising to you.
          Maybe now you will take a moment to think whether the print you’re
          holding in your hand should go to the paper recycling bin, or is it
          just a piece of single-use waste. I would like to simplify this
          process. Right now, we don’t even have clear and unambiguous
          pictograms to help us segregate waste properly. This is why we
          designed our own, easy-to-follow information on what every printed
          item is made of. I also encourage you to use paper certification icons
          on your prints and packagings. Such solutions are already very popular
          across Western Europe, where most packagings are no longer varnished
          or coated, and every box and envelope has a clear information on what
          kind of paper was used to make it. Let’s stay aware.
        </p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <p class="indend-left highlighted-text">
          PS. If you take just one thing away from our guide, let it be this:
          hey, don’t print stuff on glossy double-coated paper!
        </p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <h2 style="margin-bottom: 35px; margin-top: 0">Our pictograms</h2>
        <p>
          We have prepared a set of icons to help you transparently label your
          prints. You can use them in your products. You can use the full set
          (Polish and English) in EPS and PNG format
          <a
            href="https://bit.ly/30dvLMi"
            rel="noopener noreferrer"
            target="_blank"
            class="highlighted-text"
            >here</a
          >.
        </p>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <h2 style="margin-bottom: 35px; margin-top: 0; font-weight: 700">
          Before you print
        </h2>
        <p class="heading--sans-serif">Pre-production checklist</p>
        <ul>
          <li>Do I really need to make this?</li>
          <li>
            Do I know how I’m going to distribute this material and how long
            it’s going to be relevant?
          </li>
          <li>
            Do I know where the paper I chose comes from (what it’s called, who
            produced it, what certificates it has)
          </li>
          <li>Did I choose uncoated paper?</li>
          <li>
            Are the embellishments I chose affecting recyclability of my
            production?
          </li>
          <li>
            Did I inform my client what my production will be made of and how it
            can be utilised?
          </li>
          <li>Did I choose a local printing service provider?</li>
          <li>Did I make sure the shipment contains no single-use plastics?</li>
        </ul>
      </div>
    </div>
    <div class="row row--flex">
      <div class="col-70">
        <h2 style="margin-bottom: 35px; margin-top: 0; font-weight: 700">
          Before you print
        </h2>
        <p class="heading--sans-serif">Let's print!</p>
        <img
          v-lazy="require('@/assets/img/przedruk-schemat-01-en.jpg')"
          class="schema"
          alt
        />
      </div>
      <div class="col-30">
        <RelatedPosts :currentPostID="postID" />
      </div>
    </div>

    <ScrollToTop />
  </div>
</template>

<script>
import RelatedPosts from "../RelatedPosts";
import ScrollToTop from "../ScrollToTop";
import Sidenote from "../Sidenote";

export default {
  name: "Post6",
  components: {
    RelatedPosts,
    ScrollToTop,
    Sidenote,
  },
  props: {
    postID: Number,
  },
};
</script>

<style lang="scss">
.schema {
  max-width: 100%;
}
</style>